import { Link } from 'react-router';
import { cn } from '@rocco/utils/cn';
import type { RevampHeaderCategory } from '../type';

interface RevampCategoryPillsProps {
    categories: RevampHeaderCategory[];
    /** Extra list classes — alignment and measure differ per title section. */
    className?: string;
}

/** Outlined category pills, shared by the article revamp's title sections. */
export const RevampCategoryPills = ({
    categories,
    className,
}: RevampCategoryPillsProps) => {
    if (categories.length === 0) return null;

    return (
        <ul
            className={cn(
                'm-0 flex max-w-full list-none flex-wrap items-center gap-[0.375rem] p-0',
                className,
            )}
        >
            {categories.map((category) => (
                <li key={category.id}>
                    <Link
                        to={category.link}
                        className="flex items-center justify-center rounded-full border border-solid border-black px-[0.875rem] font-sans text-[0.75rem] leading-[1.875rem] text-[#1f1f21] uppercase no-underline transition-colors hover:bg-black hover:text-white"
                    >
                        {category.title}
                    </Link>
                </li>
            ))}
        </ul>
    );
};
